import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import LoginPage from "./pages/auth/LoginPage";
import Home from "./pages/Home";
import PrivateRoute from "./components/layout/PrivateRoute";
import SendQuotations from "./pages/measurementAndQuotation/SendQuotations";
import Allmeasurement from "./pages/measurementAndQuotation/AllMeasurements";
import AddMeasurement from "./pages/measurementAndQuotation/AddMeasurement";
import OrderListPage from "./pages/orders/OrderListPage";
import AllQuotations from "./pages/measurementAndQuotation/AllQuotations";
import CreateOrder from "./pages/orders/CreateOrder";
import Error404 from "./components/layout/Error404";
import PwaPrompt from "./components/layout/PwaPrompt";
import OrderDetail from "./pages/orders/OrderDetails";
import RevenueStats from "./pages/analytics/RevenueStats";
import ProductDistribution from "./pages/analytics/ProductDistribution";
import DealerInvoices from "./pages/invoices/DealerInvoices";
import DealerInvoiceCreate from "./pages/invoices/DealerInvoiceCreate";

function App() {
  const [isSidebar, setIsSidebar] = useState("wrapper");
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);

  // useEffect(() => {
  //   const handleBeforeInstallPrompt = (event) => {
  //     event.preventDefault();
  //     setDeferredPrompt(event);
  //     setShowInstallButton(true);
  //   };

  //   window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

  //   return () => {
  //     window.removeEventListener(
  //       "beforeinstallprompt",
  //       handleBeforeInstallPrompt
  //     );
  //   };
  // }, []);

  // const handleInstallClick = async () => {
  //   if (deferredPrompt) {
  //     deferredPrompt.prompt();
  //     const { outcome } = await deferredPrompt.userChoice;
  //     if (outcome === "accepted") {
  //       console.log("User accepted the A2HS prompt");
  //     } else {
  //       console.log("User dismissed the A2HS prompt");
  //     }
  //     setDeferredPrompt(null);
  //     setShowInstallButton(false);
  //   }
  // };
  return (
    <BrowserRouter>
      <div>
        <Routes>
          <Route
            path="/"
            element={
              <PrivateRoute
                element={<Home nav={{ isSidebar, setIsSidebar }} />}
              />
            }
          />{" "}
          <Route
            path="/order/add-measurement"
            element={
              <PrivateRoute
                element={<AddMeasurement nav={{ isSidebar, setIsSidebar }} />}
              />
            }
          />
          <Route
            path="/order/submit-quotation/:id"
            element={
              <PrivateRoute
                element={<SendQuotations nav={{ isSidebar, setIsSidebar }} />}
              />
            }
          />
          <Route
            path="/order/measurements"
            element={
              <PrivateRoute
                element={<Allmeasurement nav={{ isSidebar, setIsSidebar }} />}
              />
            }
          />
          <Route
            path="/order/list"
            element={
              <PrivateRoute
                element={<OrderListPage nav={{ isSidebar, setIsSidebar }} />}
              />
            }
          />
          <Route
            path="/order/quotations"
            element={
              <PrivateRoute
                element={<AllQuotations nav={{ isSidebar, setIsSidebar }} />}
              />
            }
          />
          <Route
            path="/order/create-order"
            element={
              <PrivateRoute
                element={<CreateOrder nav={{ isSidebar, setIsSidebar }} />}
              />
            }
          />
          <Route
            path="/order-detail/:id"
            element={
              <PrivateRoute
                element={<OrderDetail nav={{ isSidebar, setIsSidebar }} />}
              />
            }
          />
          <Route
            path="/analytics/revenue-stats"
            element={
              <PrivateRoute
                element={<RevenueStats nav={{ isSidebar, setIsSidebar }} />}
              />
            }
          />
          <Route
            path="/analytics/product-distribution"
            element={
              <PrivateRoute
                element={
                  <ProductDistribution nav={{ isSidebar, setIsSidebar }} />
                }
              />
            }
          />
          <Route
            path="/invoices/dealer-invoices"
            element={
              <PrivateRoute
                element={<DealerInvoices nav={{ isSidebar, setIsSidebar }} />}
              />
            }
          />
          <Route
            path="/invoices/dealer-invoices/create"
            element={
              <PrivateRoute
                element={
                  <DealerInvoiceCreate nav={{ isSidebar, setIsSidebar }} />
                }
              />
            }
          />
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
        {/* {showInstallButton && (
          <button onClick={handleInstallClick}>Install App</button>
        )} */}
        <PwaPrompt />
      </div>
    </BrowserRouter>
  );
}

export default App;
